export default __webpack_public_path__ + "static/media/025-y.1196864b.svg";